import { useLayoutEffect, useState } from 'react';

export const useCountNumber = (
  target: number,
  delay: number,
  startCount: boolean = false,
) => {
  const [number, setNumber] = useState(0);
  useLayoutEffect(() => {
    const count = setInterval(() => {
      if (startCount) {
        if (number !== target) {
          setNumber((number) => number + 1);
        }
      } else {
        setNumber(0);
      }
    }, delay);
    return () => {
      clearInterval(count);
    };
  }, [number, target, delay, startCount]);
  return number;
};
